export const ipMoodle = "138.68.226.91";
export const baseURL = "https://aulavirtual.linkcap.cl/";
export const tipddytoken = "587921b687c3aa3cb70b699511e3c350";
export const moodleURL = `${baseURL}webservice/rest/server.php?wstoken=`;
export const iappUrl = "https://tipddy-rnu.iapp.cl/api/rnu";

export const API = {
  dev: "http://localhost:3000/",
  prod: "https://alumnos.tuclase.cl",
};
